import { fakerPT_BR as faker } from '@faker-js/faker'
import { generateUUID } from '@fixtures/generate'
import { MockFactory } from '@tino-frontend/mocks'

import { CompanyInfo, MerchantStatus, ListMerchantsResponse } from '@types'

const COMPANY_STATUS = Object.values(MerchantStatus)

export function generateMerchant(params?: Partial<CompanyInfo>): CompanyInfo {
  const companyName = params?.company_name ?? faker.company.name()

  return {
    id: params?.id ?? generateUUID(),
    document_number: params?.document_number ?? '41077186000164',
    name: companyName,
    company_name: companyName,
    status: params?.status ?? faker.helpers.arrayElement(COMPANY_STATUS),
    created_at: params?.created_at ?? faker.date.recent().toISOString(),
    first_purchase: params?.first_purchase ?? false,
    available_limit_cents:
      params?.available_limit_cents ??
      faker.number.int({ min: 10000, max: 1000000 }),
  }
}

export const listSalespersonMerchantsMock =
  new MockFactory<ListMerchantsResponse>({
    merchants: {
      total_count: 9,
      pending_companies: [
        generateMerchant({ status: MerchantStatus.RequestedTerms }),
        generateMerchant({ status: MerchantStatus.WaitingLimitAnalisys }),
        generateMerchant({ status: MerchantStatus.PendingIdentification }),
      ],
      active_companies: [
        generateMerchant({
          status: MerchantStatus.Allowed,
          first_purchase: true,
        }),
        generateMerchant({
          status: MerchantStatus.Allowed,
          first_purchase: true,
        }),
        generateMerchant({ status: MerchantStatus.Allowed }),
        generateMerchant({ status: MerchantStatus.Allowed }),
      ],
      inactive_companies: [
        generateMerchant({ status: MerchantStatus.RejectedTerms }),
        generateMerchant({ status: MerchantStatus.BlockedLimit }),
      ],
    },
  })
